import { useContrastQuery } from '../../../../hooks/use-contrast-query'
import { Query } from '../../../../hooks/queries'
import {
  getJiraBugtracker,
  GetJiraBugtrackerArgs,
  GetJiraBugtrackerResponse
} from './requests/get-jira-bugtracker'
import {
  BugtrackerConfig,
  IntegrationConfig,
  NgBugtrackerMaintenanceWindowResource
} from './shared'
import { HTTPError } from '../../../../api/fetch/decorate-fetch'

export interface UseGetJiraBugtrackerQueryProps {
  organizationUuid?: string
  bugtrackerId: string
}

export interface GetJiraBugtrackerQueryResponse {
  bugtracker: BugtrackerConfig | undefined
  integrations: IntegrationConfig[] | undefined
  maintenanceWindow?: NgBugtrackerMaintenanceWindowResource
  error: HTTPError | null
  isError: boolean
  isLoading: boolean
}

export type UseGetJiraBugtrackerQuery = (
  props: UseGetJiraBugtrackerQueryProps
) => GetJiraBugtrackerQueryResponse

export const useGetJiraBugtrackerQuery: UseGetJiraBugtrackerQuery = ({
  organizationUuid,
  bugtrackerId
}: UseGetJiraBugtrackerQueryProps) => {
  const { data, error, isError, isLoading } = useContrastQuery<
    GetJiraBugtrackerArgs,
    GetJiraBugtrackerResponse
  >(
    [Query.INTEGRATIONS_GET_JIRA_BUGTRACKER, organizationUuid, bugtrackerId],
    getJiraBugtracker,
    {
      organizationUuid,
      bugtrackerId
    },
    { enabled: !!bugtrackerId }
  )

  return {
    bugtracker: data?.bugtracker,
    integrations: data?.integrations,
    maintenanceWindow: data?.maintenanceWindow,
    error,
    isError,
    isLoading
  }
}
